import {
	MapType,
	ModelTypes,
	ValueTypes,
	ZeusSelect,
} from '@goodlok/sdk/generated/content_role_admin'

export function EmployeeRoleFragment() {
	return ZeusSelect<ValueTypes['TimetableEmployeeRole']>()({
		id: true,
		name: true,
	})
}

export type EmployeeRoleResult = MapType<
	ModelTypes['TimetableEmployeeRole'],
	ReturnType<typeof EmployeeRoleFragment>
>
